import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton,
} from '@mui/material';
import { useDropzone } from 'react-dropzone';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import useApiManager from '../../../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';

const FileUploadDialog = ({ open, onClose, fetchLeadAttachments }) => {
    const [files, setFiles] = useState([]);
    const { leadId } = useParams();
    const { post } = useApiManager();

    const onDrop = (acceptedFiles) => {
        setFiles(acceptedFiles);
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('attachment', file);

        const url = `/leads/${leadId}/attachments/file`;

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        try {
            await post(url, formData, config);

        } catch (error) {
            console.error('Error uploading file:', error);
            throw error; // Handle the error appropriately
        }
    };

    const handleAttach = async () => {
        try {
            if (files.length > 0) {
                const response = await uploadFile(files[0]);
                console.log('File uploaded successfully:', response);
                onClose();
            }
        } catch (error) {
            console.error('Error uploading files:', error);
        }
    };

    const handleClose = () => {
        setFiles([]);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Attach Files</DialogTitle>
            <DialogContent>
                <Box
                    {...getRootProps()}
                    sx={{
                        border: '2px dashed #1976d2',
                        borderRadius: '10px',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                    }}
                >
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <Typography variant="body1" color="primary">
                            Drop the files here...
                        </Typography>
                    ) : (
                        <Box>
                            <IconButton>
                                <AttachFileIcon fontSize="large" />
                            </IconButton>
                            <Typography variant="body1">
                                Drop files to attach or browse
                            </Typography>
                        </Box>
                    )}
                </Box>
                {files.length > 0 && (
                    <Box mt={2}>
                        <Typography variant="body2">Files:</Typography>
                        <ul>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleAttach}
                    color="primary"
                    variant="contained"
                >
                    Attach
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FileUploadDialog;
